import { isFilled } from './isFilled.js';
export const noCache = {
    get: () => undefined,
    set: () => { },
    delete: () => false,
    clear: () => { }
};
export const defaultCache = new Map();
export const applyCache = (fetcher, cache = defaultCache) => (args) => {
    const key = computeKey(args);
    const cachedData = cache.get(key);
    if (key && isFilled(cachedData)) {
        return cachedData;
    }
    const data = fetcher(...args);
    if (key && isFilled(data)) {
        cache.set(key, Promise.resolve(data));
    }
    return data;
};
const isKey = (args) => Boolean(args?.every(_ => (Array.isArray(_) ? isKey(_) : !_ || typeof _ === 'string')));
const computeKey = (args) => (isKey(args) ? args.toString() : '');
